import { render, staticRenderFns } from "./OpenFolder.vue?vue&type=template&id=07114aba&"
import script from "./OpenFolder.vue?vue&type=script&lang=js&"
export * from "./OpenFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports